import React from 'react';
import { Row, Col } from 'antd';

import Header from '../Landing/HomeHeader';
import Footer from './Footer';

import style from './TurnSection.module.scss';

export default function EorEmployerOfRecordServices() {
  return (
    <>
      <Header />
      <main className="typography">
        <section className={style.turnSection}>
          <div className="container">
            <h1 className="info-title underline">
              TURNKEY{' '}
              <span>
                <span className="fake"></span>OR
              </span>
            </h1>
            <div className={style.content}>
              <h3 className="info-subtitle">
                We are an on-demand Employer & payroll platform for the
                contingent workforce
              </h3>
              <div className="text-box">
                <p>
                  myBasePay gives you the ability to place contract workers with
                  your customers anywhere in the U.S. – with a global footprint.
                </p>
                <p>
                  As advocates for the contingent workforce, myBasePay combines
                  the urgency talent professionals demand with a benefits
                  package the external worker deserves. We provide and sponsor
                  the benefits needed to retain and compete for top talent:
                </p>
              </div>
              <ul className="default-list rectangle">
                <li>PTO eligibility for all full-time employees</li>
                <li>Monthly copays on health insurance premiums</li>
                <li>
                  Flexible health insurance options based on the unique needs of
                  each worker
                </li>
              </ul>
            </div>
            <div className={style.background}>
              <h3 className="info-subtitle underline">
                Is your business struggling with these employment and payroll
                liability challenges?
              </h3>
              <ul className="default-list arrow">
                <li>Tax and risk burdens</li>
                <li>Redundant employee onboarding processes</li>
                <li>Liability for gig workers</li>
                <li>Compliance costs (direct and indirect)</li>
                <li>Oversight of highly regulated employment types</li>
                <li>
                  Turnover costs - unemployment taxes, onboarding, offboarding
                </li>
                <li>Burdensome vendor requirements</li>
              </ul>
            </div>
            <div className={style.content}>
              <h3 className="info-subtitle">
                As the designated Employer of your contingent Workforce,
                myBasePay oversees:
              </h3>
              <Row gutter={[20, 40]}>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">
                    Compliant Screening <br />
                    Measures
                  </div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">
                    Timely Onboarding and <br />
                    Payroll Processing
                  </div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex d-lg-block"></Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">
                    Tax Withholding and Deposits
                  </div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">
                    Insurance Coverage for <br />
                    Assigned Employees
                  </div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">
                    Administration of Employee <br />
                    Health Benefits
                  </div>
                </Col>
              </Row>
            </div>
            <div className={style.content}>
              <h3 className="info-subtitle">
                Streamlined talent onboarding that simplifies the engagement process
                while ensuring adherence to your customers' unique requirements
                <br />
                <br />
                EOR capabilities for a wide range of industries:
              </h3>
              <Row gutter={[20, 40]}>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">Accounting and Finance</div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">Information Technology</div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">Creative and Marketing</div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">
                    Administrative and Clerical
                  </div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">General Counsel and Legal</div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">Insurance and Mortgage</div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">Engineering</div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">Life Sciences</div>
                </Col>
                <Col xs={24} sm={12} xl={8} className="d-flex">
                  <div className="feature-card">Executive Сonsutlants</div>
                </Col>
              </Row>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
